"use strict";

/* eslint-disable max-len */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_LICENSE = void 0;
var bytes_serialiser_1 = require("./../serialisers/bytes-serialiser");
var replace_licence_response_serialiser_1 = require("./../services/replace-licence/replace-licence-response-serialiser");
exports.UPDATE_LICENSE = {
  id: 159,
  request: bytes_serialiser_1.BytesSerialiser,
  response: replace_licence_response_serialiser_1.ReplaceLicenceResponseSerialiser
};